import React, { memo, useEffect } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import style from './PasswordHints.scss';
import * as action from './actions';

export const PasswordHints = memo(({ isFocused, input }) => {
    const statuses = ['length', 'number', 'letter', 'symbol'];
    const invisibleStatuses = ['info', 'space', 'maxlength', 'firstName', 'lastName', 'userName', 'umlaut', 'notSupportedSymbols'];
    const t = useTranslations();
    const { lastName, firstName, username } = window.Playtech.fetchUserDetails();

    useEffect(() => {
        action.checkRegexp(input, firstName, lastName, username);
    }, [input]);

    return (
        <fieldset className={`${style.passwordRule} ${isFocused ? style.showSection : style.hideSection} passwordHints`} >
            <div className={style.field}>
                <div className={style.passwordContainerRules}>
                    {statuses.map((status, key) =>
                        <div className={style.ruleItem} data-status={status} key={key}>
                            <span className={style.ruleStatus}></span>
                            <span className={style.ruleText}>
                                {t(`playtech.mobile.system.user.tooltip.password.rule.${status}`)}
                            </span>
                        </div>
                    )}
                    <div className={style.invisibleItem} >
                        {invisibleStatuses.map((status, key) =>
                            <div className={`${style.ruleItem} 'hidden' ${status === 'info' ? style.information : ''}`}
                                 data-status={status}
                                 key={key}>
                                <span className={style.ruleStatus}></span>
                                <span className={style.ruleText}>
                                    {t(`playtech.mobile.system.user.tooltip.password.rule.${status}`)}
                                </span>
                            </div>
                        )}
                        <hr/>
                    </div>
                </div>
            </div>
        </fieldset>
    );
});
